import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {checkInToken, type CheckInResult} from '@/api/repositories/CheckInRepository';

declare module 'vue-router' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- module augmentation requires an interface
    interface RouteMeta {
        checkInResult?: CheckInResult;
    }
}

export async function handleCheckIn(to: RouteLocationNormalized): Promise<NavigationGuardReturn> {
    const token = to.params.token;

    if (typeof token !== 'string') {
        return {name: 'Login'};
    }

    try {
        const result = await checkInToken(token);

        if (result !== null) {
            to.meta.checkInResult = result;

            return;
        }
    } catch {
        // NOP
    }

    return {name: 'Login'};
}
